var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-topbar',{attrs:{"minimized":_vm.minimized}},[_c('template',{slot:"menu"},[_vm._l((_vm.items),function(item,key){return [(item.children)?_c('topbar-link-group',{key:key,attrs:{"minimized":_vm.minimized,"icon":[
          item.meta.iconSet
            ? item.meta.iconSet
            : 'sidebar-menu-item-icon vuestic-iconset',
          item.meta.iconClass
        ],"title":_vm.$t(item.displayName)}},_vm._l((item.children),function(subMenuItem,key){return _c('topbar-link',{key:key,attrs:{"activeByDefault":subMenuItem.name === _vm.$route.name,"to":{ name: subMenuItem.name },"title":_vm.$t(subMenuItem.displayName)}})}),1):_c('topbar-link',{key:key,attrs:{"minimized":_vm.minimized,"activeByDefault":item.name === _vm.$route.name,"icon":[
          item.meta.iconSet
            ? item.meta.iconSet
            : 'sidebar-menu-item-icon vuestic-iconset',
          item.meta.iconClass
        ],"to":{ name: item.name }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t(item.displayName)))])])]})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }